import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedLabelAreaColumn: CalculationColumn = {
    dataIndex: ['calculated', 'labelArea'],
    title: 'Площадь этикетки',
    width: 80,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => formatIntegerBySpace(r.calculated?.labelArea || 0)),
}
